import React from 'react';
import { Truck } from 'lucide-react';

const TopBanner = () => (
  <div
    className="w-full flex items-center justify-center gap-2 py-2 px-4 text-[12px] tracking-wide font-medium"
    style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
  >
    <Truck size={14} />
    <span>✓ Free Shipping Worldwide · No Hidden Fees</span>
  </div>
);

export default TopBanner;
